import type { ReactNode } from 'react';

import { NotifyBell } from '../push/Bell.tsx';
import { DartMark } from './DartMark.tsx';
import { Flame } from './icons.tsx';

/**
 * The brand row over Today, Play, Nest and You: the Dart + "sparrow" wordmark and, once
 * there is one, the streak, then the notifications bell and ≡ (`after`). Today adds the
 * desktop Install button `before` the streak. The bell hides itself where push can't work.
 */
export function BrandRow({
	streak,
	className,
	before,
	after,
	bell = true,
}: {
	streak: number;
	className?: string;
	before?: ReactNode;
	after?: ReactNode;
	bell?: boolean;
}) {
	const streakEl =
		streak > 0 ? (
			<span className="streak" role="img" aria-label={`${streak}-day streak`}>
				<Flame />
				<span aria-hidden="true">{streak}</span>
			</span>
		) : null;
	return (
		<header className={className ? `brandrow ${className}` : 'brandrow'}>
			<p className="brand">
				<DartMark className="brand-mark" />
				<span className="wm">sparrow</span>
			</p>
			{before || after ? (
				<span className="brandrow-r">
					{before}
					{streakEl}
					{bell && <NotifyBell />}
					{after}
				</span>
			) : (
				streakEl
			)}
		</header>
	);
}
